import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    meetingRoomPayment: null,
    error: null
};

export const meetingRoomPaymentSlice = createSlice({
    name: "meetingRoomPayment",
    initialState: initialState,
    reducers: {

        catchError: (state, action) => {
            state.error = { ...action.payload.error };
            state.loading = false;
        },

        startCall: (state, action) => {
            state.error = null;
            state.loading = true;
        },

        meetingRoomPaymentCreated: (state, action) => {
            state.loading = false;
            state.error = null;
            state.meetingRoomPayment = action.payload.meetingRoomPayment;
        },
    }
});
